<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Insegurança alimentar"
            description="Triagem para Risco de Insegurança Alimentar (TRIA) na APS por família"
            url="/dashboard"
          />
        </div>
      </div>
      <router-view></router-view>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from './SectionTitle'

export default {
  components: {
    Menu,
    Footer,
    SectionTitle,
  },
  metaInfo: {
    title: 'Tria',
    titleTemplate: null,
  },
  data() {
    return {
      linksAjudaPec: [],
      linksAjudaCds: [],
    }
  },
}
</script>

<style></style>
